<template>
  <div class="strapi-components *:mb-28">
    <template v-for="c in product.content">
      <strapi-button
        v-if="c.component === 'generic.button'"
        :key="`${c.component}__${c.id}`"
        :component="c"
      />
      <strapi-banner
        v-if="c.component === 'generic.banner'"
        :key="`${c.component}__${c.id}`"
        :component="c"
      />
      <strapi-product-order-configurations
        v-if="
          c.component === 'product.order-configurations' && product.orderUrl
        "
        :key="c.component"
        :component="c"
        :product-key="product.productKey"
        :product-type="product.type"
        :chargebee-plan-id="product.chargebeePlanId"
        :order-url="product.orderUrl"
        :pre-order="isPreOrder"
        :is-discounted-game="product.isDiscountedGame"
        :discounted-percentage="product.discountedPercentage"
      />
      <strapi-product-benefits
        v-if="c.component === 'product.benefits'"
        :key="`${c.component}__${c.id}`"
        :component="c"
      />
      <lazy-strapi-media-gallery
        v-if="
          c.component === 'media-gallery' || c.component === 'product.gallery'
        "
        :key="`${c.component}__${c.id}`"
        :component="c"
      />
      <lazy-strapi-product-you-tube
        v-if="c.component === 'product.you-tube-video'"
        :key="`${c.component}__${c.id}`"
        :component="c"
      />
      <lazy-strapi-product-content
        v-if="c.component === 'product.content'"
        :key="`${c.component}__${c.id}`"
        :component="c"
        :in-container="true"
      />
      <strapi-reviews
        v-if="c.component === 'product.reviews'"
        :key="`${c.component}__${c.id}`"
        :component="c"
      />
      <lazy-strapi-product-payments
        v-if="c.component === 'product.payments'"
        :key="`${c.component}__${c.id}`"
        :component="c"
      />
      <lazy-strapi-product-faq
        v-if="c.component === 'product.faqs'"
        :key="`${c.component}__${c.id}`"
        :component="c"
      />
      <lazy-strapi-product-locations-map
        v-if="c.component === 'product.locations-map'"
        :key="`${c.component}__${c.id}`"
        :component="c"
      />
      <strapi-product-custom-components
        v-if="c.component === 'product.custom-component'"
        :key="`${c.component}__${c.id}`"
        :component="c"
        :order-url="product.orderUrl"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import type { StrapiProduct } from '~/apollo/types/types';

const props = defineProps<{
  product: StrapiProduct;
}>();

const isPreOrder = computed<boolean>(() =>
  timeIsAfterNow(props.product.releaseAt),
);
</script>
